module.exports = __webpack_public_path__ + "img/FR17799.5bb622fd.png";